/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsHexagonFill: {
  name: 'hexagon-fill';
  data: string;
} = {
  name: 'hexagon-fill',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.894 2.33a2 2 0 0 0-1.788 0l-7 3.5A2 2 0 0 0 3 7.617v8.764a2 2 0 0 0 1.106 1.789l7 3.5a2 2 0 0 0 1.788 0l7-3.5A2 2 0 0 0 21 16.382V7.618a2 2 0 0 0-1.106-1.789l-7-3.5Z" fill="currentColor"/></svg>`,
};
